import axios from 'axios';
import { HTTP_FORBIDDEN_CODE } from 'constants/constants';

import store from './store/store';

// APIs to bypass 401 redirect
const BYPASS_URLS = ['authenticate'];
const axiosDBClient = () => {
  const defaultOptions = {
    baseURL: `${process.env.REACT_APP_API_HOST}/api/`,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  // Create instance
  let instance = axios.create(defaultOptions);

  // Request interceptor
  instance.interceptors.request.use(
    function (config) {
      config.headers.Authorization = `Bearer ${localStorage.getItem('c360-token')}`;
      config.headers.qlikCookie = localStorage.getItem('qlikCookie');
      config.headers['x-user-role'] =
        store.getState()?.Auth?.userClaimObject?.roleId;
      return config;
    },
    (error) => Promise.reject(error)
  );

  // Response interceptor
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === HTTP_FORBIDDEN_CODE) {
        const url = error.config?.url || '';
        const shouldBypass = BYPASS_URLS.some((bypassUrl) =>
          url.includes(bypassUrl)
        );
        if (!shouldBypass) {
          window.location.href = '/logout';
        }
      }
      return Promise.reject(error);
    }
  );

  return instance;
};

export default axiosDBClient();
